import React, { useState } from "react";
import fordStyles from "./SharedToolTip.module.scss";
import lincolnStyles from "./LincolnSharedToolTip.module.scss";
import Clear from "@mui/icons-material/Clear";
import { styled } from "@mui/material/styles";
import { withTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import AlertIcon from "../../imgs/error/error.png";

const StyledClear = styled(Clear)({
  color: "#102b4e",
});

const StyledTooltip = styled(Tooltip)({
  "& .MuiTooltip-popper": {
    opacity: 1,
    pointerEvents: "auto",
  },
  "& .MuiTooltip-tooltip": {
    background: "white",
    boxShadow: "1px 1px 9px 0 rgba(0, 0, 0, 0.27)",
    paddingTop: 28,
    paddingLeft: 28,
    paddingRight: 28,
    paddingBottom: 18,
    maxWidth: 350,
  },
});

const AlertToolTip = (props) => {
  const [open, setOpen] = useState(false);

  const closeTooltip = (event) => {
    event.stopPropagation();
    setOpen(false);
  };

  const openTooltip = (event) => {
    event.stopPropagation();
    setOpen(true);
  };

  const styles = props.isLincolnBrand ? lincolnStyles : fordStyles;

  return (
    <StyledTooltip
      placement="bottom-start"
      open={open}
      title={
        <div>
          <button
            onClick={closeTooltip}
            className={styles.exitButton}
            data-testid={props.closeTestid}
          >
            <StyledClear />
          </button>
          <div className={styles.header}>{props.title}</div>
          <div className={styles.bodyContent}>{props.body}</div>
        </div>
      }
    >
      <img
        alt="Tooltip"
        data-testid={props.openTestid}
        className={styles.tooltipImg}
        onClick={(event) => openTooltip(event)}
        src={AlertIcon}
      />
    </StyledTooltip>
  );
};

export default withTranslation("emp")(AlertToolTip);
